import { PublicationLayoutProps } from "../../api/publications"
import { Blockquote, Box, Card, Center, Float, Grid, GridItem, Heading, Spinner, Text, Image, Button, Flex, Container, Link as LinkR } from "@chakra-ui/react"
import { Link } from "@tanstack/react-router"

import jakob from "../../../public/assets/images/jakobmarkt-inserat.jpg"


const LayoutFirstBigNoImage = ({
    publications,
    isPending,
    title,
    category_img_path,
    handleLoadMore,
    isLoadingMore,
    showMore
}: PublicationLayoutProps) => {
    const [first, ...rest] = publications ?? []

    return (
        <>
            {isPending ? (
                <Center
                    position="fixed"
                    top="0"
                    left="0"
                    width="100vw"
                    height="100vh"
                    zIndex="10000"
                    pointerEvents="none"
                >
                    <Spinner size="lg" color="main" />
                </Center>
            ) : (
                <>
                    <Heading size="4xl" color="main" mb={5}>{title}</Heading>
                    {category_img_path &&
                        <Box
                            h="7em"
                            bgColor="mainOpacity"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Image src={category_img_path.replace(/-(LG)\./, "-MD.")} alt="Category image" h="80%" />
                        </Box>
                    }

                    {publications?.length != 0 ? (
                        <>
                        {first &&
                            <Link to="/$slug" params={{ slug: first.classic_id }}>
                                <Card.Root w="100%" my={10} data-testid="publication_card">
                                    <Card.Header pos="relative" h="2em">
                                        <Float
                                            display="block"
                                            pos="absolute"
                                            top={3}
                                            left={-3}
                                            translate="none"
                                            backgroundColor="mainOpacity"
                                            color="white"
                                            px={5}
                                            py={0.5}
                                            w="fit-content"
                                            boxShadow="rgba(0, 0, 0, 0.35) 0px 5px 15px"
                                        >
                                            <Text hyphens="auto" data-testid="publication_card_subtitle" fontWeight="bold">
                                                {first.subtitle && first.subtitle != "" ? first.subtitle : first.fk_categories.at(0)?.name}
                                            </Text>
                                        </Float>
                                    </Card.Header>
                                    <Card.Body
                                        gap="2"
                                        w="full"
                                        h="full"
                                        p={3}
                                    >
                                        <Blockquote.Root borderInlineStartColor="main" my={5}>
                                            <Blockquote.Content fontSize={{sm: "14pt", md: "24pt"}} hyphens="auto" data-testid="publication_card_title">{first.title}</Blockquote.Content>
                                        </Blockquote.Root>

                                        {first.lead ? (
                                            <Card.Description
                                                lineClamp={5}
                                                hyphens="auto"
                                                data-testid="publication_card_desc"
                                                color="black"
                                            >
                                                {first.lead}
                                            </Card.Description>
                                        ) : (
                                            <Card.Description
                                                lineClamp={5}
                                                hyphens="auto"
                                                data-testid="publication_card_desc"
                                                color="black"
                                                dangerouslySetInnerHTML={{ __html: first.content }}
                                            />
                                        )}
                                    </Card.Body>
                                </Card.Root>
                            </Link>
                        }

                        {rest &&
                            <Grid
                                my={20}
                                templateColumns={{
                                    base: "repeat(1, 1fr)",
                                    lg: "repeat(2, 1fr)",
                                    xl: "repeat(2, 1fr)",
                                    "2xl": "repeat(4, 1fr)",
                                }}
                                gap="2em"
                                justifyItems="center"
                                justifyContent="center"
                            >
                                {rest.map((publication) => (
                                    <GridItem cursor="pointer" key={publication.id} w="full">
                                        <Link to="/$slug" params={{ slug: publication.classic_id }}>
                                            <Card.Root
                                                maxW={{xl: "lg", "2xl": "2xs"}}
                                                w="full"
                                                h="full"
                                                data-testid="publication_card"
                                            >
                                                <Card.Header pos="relative" h="2em">
                                                    <Float
                                                        display="block"
                                                        pos="absolute"
                                                        top={3}
                                                        left={-3}
                                                        translate="none"
                                                        backgroundColor="mainOpacity"
                                                        color="white"
                                                        px={5}
                                                        py={0.5}
                                                        w="90%"
                                                        minH="24px"
                                                        boxShadow="rgba(0, 0, 0, 0.35) 0px 5px 15px"
                                                    >
                                                        <Text hyphens="auto" data-testid="publication_card_subtitle" fontWeight="bold">
                                                            {publication.subtitle && publication.subtitle != "" ? publication.subtitle : publication.fk_categories.at(0)?.name}
                                                        </Text>
                                                    </Float>
                                                </Card.Header>

                                                <Card.Body
                                                    gap="2"
                                                    w="full"
                                                    h="full"
                                                    p={3}
                                                    justifyContent="space-between"
                                                >
                                                    <Blockquote.Root borderInlineStartColor="main" my={5}>
                                                        <Blockquote.Content
                                                            hyphens="auto"
                                                            data-testid="publication_card_title"
                                                            fontWeight="bold"
                                                        >
                                                            {publication.title}
                                                        </Blockquote.Content>
                                                    </Blockquote.Root>
                                                    {publication.lead ? (
                                                        <Card.Description
                                                            lineClamp={5}
                                                            hyphens="auto"
                                                            data-testid="publication_card_desc"
                                                            color="black"
                                                        >
                                                            {publication.lead}
                                                        </Card.Description>
                                                    ) : (
                                                        <Card.Description
                                                            lineClamp={5}
                                                            hyphens="auto"
                                                            data-testid="publication_card_desc"
                                                            color="black"
                                                            dangerouslySetInnerHTML={{ __html: publication.content }}
                                                        />
                                                    )}
                                                </Card.Body>
                                            </Card.Root>
                                        </Link>
                                    </GridItem>
                                ))}
                            </Grid>
                        }

                        {showMore && (
                            <Flex justifyContent="center">
                                <Button
                                    onClick={handleLoadMore}
                                    variant="secondary"
                                    textTransform="uppercase"
                                    mt="10"
                                    w="12em"
                                >
                                    {isLoadingMore ? <Spinner size="sm" /> : "Mehr Beiträge laden"}
                                </Button>
                            </Flex>
                        )}
                        </>
                    ) : (
                        <Container
                            h="30em"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            textAlign="center"
                        >
                            <Text
                                fontSize="3xl"
                                color="main"
                                fontWeight="bold"
                                mb={4}
                            >
                                Hier gibt es noch keine Beiträge
                            </Text>
                        </Container>
                    )}
                </>
            )}

            <Flex direction="column" alignItems="center" hideFrom="md" my={32} gap={32}>
                <LinkR href="https://www.jakob-markt.ch/jakob-schuehparadies.html" target="_blank" w="100%" cursor="pointer"><Image src={jakob} alt="Jakob's Schuehparadies" /></LinkR>
            </Flex>
        </>
    )
}

export default LayoutFirstBigNoImage
